import moment from "moment";

// Constants
import { DATE_FORMAT } from "@/Constants/date";

export const emptyValidation = (value, options) => {
	if (options?.acceptZero && !isNaN(value)) {
		return true;
	}

	if (value && options?.maxLength && value.length > options?.maxLength) {
		return false;
	}

	if (value && options?.minLength && value.length <= options?.minLength) {
		return false;
	}

	return Boolean(value);
};

export const dateValidation = (value) => moment(value).isValid();

export const overlapsValidation = (value) => {
	const { effectiveDateFrom, effectiveDateTo, rowEffeDateFrom, rowEffeDateTo } = value;
	const formatDate = (date) => (date ? moment(moment.utc(date).format(DATE_FORMAT.usDateDash)).startOf("day") : null);

	const areDatesPresent = effectiveDateFrom && effectiveDateTo && rowEffeDateFrom && rowEffeDateTo;
	const isRowEffeDateToAbsent = rowEffeDateFrom && !rowEffeDateTo;
	const areDatesEqual = moment(formatDate(effectiveDateFrom)).format() === moment(formatDate(rowEffeDateFrom)).format();

	if (isRowEffeDateToAbsent && areDatesEqual) {
		return true;
	}

	if (!areDatesPresent) {
		return false;
	}

	const fromDate = formatDate(effectiveDateFrom);
	const toDate = formatDate(effectiveDateTo);
	const rowEffFrom = formatDate(rowEffeDateFrom);
	const rowEffTo = formatDate(rowEffeDateTo);

	return fromDate <= rowEffTo && toDate >= rowEffFrom;
};

export const overlapsRangeValidation = (value) => {
	const { rowEffectiveFrom, rowEffectiveTo, effectiveDateFrom, effectiveDateTo } = value;

	// Convert the dates to JavaScript Date objects
	const fromDate = new Date(effectiveDateFrom);
	const toDate = new Date(effectiveDateTo);
	const rowFromDate = new Date(rowEffectiveFrom);
	const rowToDate = new Date(rowEffectiveTo);

	// Check if the date ranges overlap
	return fromDate <= rowToDate && toDate >= rowFromDate;
};
